import React, { useState } from 'react';
import { useGameStore, selectCurrentSentence } from '../store/gameStore';
import Slot from './Slot';

const DropZone = () => {
  const [isDragOver, setIsDragOver] = useState(false);
  const { slotContents, tileSize, tilesFeedback, showPinyin, clearSelection } = useGameStore();
  const currentSentence = useGameStore(selectCurrentSentence);
  
  if (!currentSentence) return null;
  
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };
  
  const handleDragLeave = () => {
    setIsDragOver(false);
  };
  
  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };
  
  const handleClick = () => {
    clearSelection();
  };
  
  const zoneStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: `${Math.max(6, tileSize * 0.14)}px`,
    minHeight: '80px',
    padding: '16px',
    background: tilesFeedback === 'correct' ? '#052e16' :
                tilesFeedback === 'wrong' ? '#2e0505' : '#1e293b',
    border: tilesFeedback === 'correct' ? '2px solid #22c55e' : 
            tilesFeedback === 'wrong' ? '2px solid #ef4444' :
            isDragOver ? '2px dashed #6366f1' : '2px dashed #334155',
    borderRadius: '16px',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'border-color 0.2s, background 0.2s',
    animation: tilesFeedback === 'correct' ? 'pulse-green 0.6s ease' :
               tilesFeedback === 'wrong' ? 'shake 0.4s ease' : 'none',
  };
  
  const pinyinStyle = {
    textAlign: 'center',
    fontSize: '1rem',
    color: '#a5b4fc',
    minHeight: '24px',
    marginTop: '12px',
  };
  
  return (
    <div>
      <div className="section-label">Build the sentence here — tap slot to place</div>
      <div 
        className={`drop-zone ${tilesFeedback || ''} ${isDragOver ? 'drag-over' : ''}`}
        style={zoneStyle}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={handleClick}
      >
        {slotContents.map((tile, index) => (
          <Slot key={index} index={index} tile={tile} />
        ))}
      </div>
      
      {showPinyin && (
        <div style={pinyinStyle}>
          {currentSentence.pinyin}
        </div>
      )}
    </div>
  );
};

export default DropZone;
